import React, { useState, Fragment, useEffect, useRef } from 'react';
//
import './Home.css';
//
import LeftSidebar from './components/LeftSidebar/LeftSidebar';
import RightSidebar from './components/RightSidebar/RightSidebar';
import Content from './components/Content/Content';
import Joyride, { STATUS } from 'react-joyride';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import StripeFailure from 'container/Dialogs/StripeFailure/StripeFailure';
import StripeSuccess from 'container/Dialogs/StripeSuccess/StripeSuccess';
import { useSearchParams } from 'react-router-dom';
// import SIgnUp from 'container/Dialogs/SignUp/SIgnUp';
// import Subscription from 'container/Dialogs/Subscription/Subscription';
import classNames from 'classnames';
import UpgradeBanner from 'container/components/UpgradeBanner/UpgradeBanner';
import ShareDialog from 'container/Dialogs/ShareDialog/ShareDialog';
import ImageGeneration from './components/ImageGeneration/ImageGeneration';

import AiImagesDetailsDialog from '../../Dialogs/AiImagesDetailDialog/ImageDetailDialog';
import { tutorialSteps } from 'container/data/tutorialsConfig';
import styled from 'styled-components';
import CountryBanner from 'container/components/CountryBanner/CountryBanner';
// import SalesBanner from 'container/components/SalesBanner/SalesBanner';
// import { bannerText } from 'app.config';

function Home() {
  const dispatch = useDispatch();
  const [mobileSidebar, setMobileSidebar] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const params = useSearchParams()[0];
  const id = params.get('id')?.split('?')[0] || '';
  const plan_id = params.get('plan_id') || '';
  const signup = params.get('signup');
  const cancel = params.get('cancel') || '';
  const discountCode = params.get('discount_code') || '';
  const sendGifts = params.get('send_gifts') || '';
  const buyPlan = params.get('buy_plan') || '';
  const isLeftSideBarOpen = useSelector(state => state.utils.isLeftSideBarOpen);
  const model = useSelector(state => state.chat.model);
  const isRightSideBarOpen = useSelector(
    state => state.utils.isRightSideBarOpen
  );

  const { modalData } = useSelector(state => state.imageGeneration);
  const { countryBanner } = useSelector(state => state.location);
  const planData = useSelector(state => state.subscription.planData);
  // User Data
  const loading = useSelector(state => state.auth.loading);
  const userData = useSelector(state => state.auth.user);
  const [stripeSuccess, setStripeSuccess] = useState(false);
  const [stripeFailoure, setStripeFailure] = useState(false);
  const [subscriptionModal, setSubscriptionModal] = useState(false);
  const [signUpModal, setSignUpModal] = useState(false);
  const [showTut, setShowTut] = useState(false);

  const rightSideBarRef = useRef(null);

  const handleCallback = data => {
    const { status } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      localStorage.setItem('skipTut', 'true');
    }
  };

  // Get User Details
  useEffect(() => {
    if (token) {
      dispatch.auth.handleGetUser();
    }
    if (signup) {
      setSignUpModal(true);
    }
    dispatch.chips.handleGetChips();
    dispatch.imageGeneration.getTemplates();
    dispatch.imageGeneration.getFilters();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (plan_id && id) {
      setStripeSuccess(true);
    }
  }, [plan_id, id]);

  useEffect(() => {
    if (cancel) {
      setStripeFailure(true);
    }
  }, [cancel]);

  useEffect(() => {
    if (discountCode) {
      if (token) {
        dispatch.utils.setSubscriptionModal(true);
      } else {
        if (!signup) {
          navigate('/sign-in?buy_plan=true');
        }
      }
    }
    // eslint-disable-next-line
  }, [discountCode, token]);

  useEffect(() => {
    if (buyPlan) {
      dispatch.utils.setSubscriptionModal(true);
    }
    // eslint-disable-next-line
  }, [buyPlan]);

  useEffect(() => {
    if (localStorage.getItem('skipTut') === 'true') {
      setShowTut(false);
    } else {
      setShowTut(true);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (sendGifts) {
      navigate('/settings/gifts');
    }
    // eslint-disable-next-line
  }, [sendGifts]);

  return (
    <Container>
      {/* {planData?.plan?.toLowerCase() === 'free' && (
        <SalesBanner label={bannerText} showLink />
      )} */}
      {planData?.plan?.toLowerCase() === 'free' && countryBanner && (
        <CountryBanner />
      )}
      <Fragment>
        {showTut && model.value === 'picasso' && (
          <Joyride steps={tutorialSteps} callback={handleCallback} />
        )}
        <div
          className='home-container'
          style={{
            flexGrow: 1,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {userData?.profile?.status === 5 && <UpgradeBanner />}
          <div
            className='row gx-0'
            style={{
              flexGrow: 1,
              overflow: 'hidden',
            }}
          >
            {/* Left SideBar */}
            <div
              className={classNames(
                'left-sidebar-col col-md-3',
                isLeftSideBarOpen ? 'open' : 'close'
              )}
            >
              <LeftSidebar setSignUpModal={setSignUpModal} />
            </div>
            {/* Content */}
            <div className='content-col col-md-6'>
              {model.value === 'picasso' ? (
                <ImageGeneration sideBar={rightSideBarRef} />
              ) : (
                <Content
                  signUpModal={signUpModal}
                  setSignUpModal={setSignUpModal}
                  subscriptionModal={subscriptionModal}
                  setSubscriptionModal={setSubscriptionModal}
                  mobileSidebar={mobileSidebar}
                  setMobileSidebar={setMobileSidebar}
                />
              )}
            </div>
            {/* Right SideBar */}
            <div
              className={classNames(
                'right-sidebar-col col-md-3',
                isRightSideBarOpen ? 'open' : 'close'
              )}
              ref={rightSideBarRef}
            >
              <RightSidebar
                setSignUpModal={setSignUpModal}
                setSubscriptionModal={setSubscriptionModal}
                userData={userData}
                loading={loading}
                token={token}
              />
            </div>
          </div>
        </div>
        {stripeFailoure && (
          <StripeFailure open={stripeFailoure} setOpen={setStripeFailure} />
        )}
        {stripeSuccess && (
          <StripeSuccess
            userId={id}
            plan_id={plan_id}
            open={stripeSuccess}
            setOpen={setStripeSuccess}
          />
        )}
        <ShareDialog />
        {modalData && <AiImagesDetailsDialog />}
      </Fragment>
    </Container>
  );
}

export default Home;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  min-height: 100vh;
`;
